import { faTimelineArrow } from "@fortawesome/pro-light-svg-icons";
import { faRobot } from "@fortawesome/pro-solid-svg-icons";

import { Issue } from "@protos/issues/v1/issues";
import { ICON_MAP } from "@shared/components/lib/CodeLocationIconList/ValidationStateIcon";
import { SECRETS_AI_RULESET } from "@shared/utils";

import { InfoIcon } from "../../types/infoIcon";

import { generateSastIcons } from "./generateSastIcons";

export function generateSecretsIcons(finding: Issue): InfoIcon[] {
  const sastIcons = generateSastIcons(finding);
  const secretsIcons = [...sastIcons];

  // Insert secrets-specific icons before the last two sast icons (branch info)
  let insertIndex = secretsIcons.length - 2;

  if (finding.secretsAttributes?.validationState) {
    const iconData = ICON_MAP[finding.secretsAttributes.validationState];
    if (iconData) {
      secretsIcons.splice(insertIndex++, 0, {
        icon: iconData.icon,
        label: iconData.label,
      });
    }
  }

  if (finding.secretsAttributes?.historicalInfo) {
    secretsIcons.splice(insertIndex++, 0, {
      icon: faTimelineArrow,
      label: "Historical",
      iconProps: { flip: "horizontal" },
    });
  }

  if (finding.ruleset === SECRETS_AI_RULESET) {
    secretsIcons.splice(insertIndex++, 0, {
      icon: faRobot,
      label: "analyzed by Assistant",
    });
  }

  return secretsIcons;
}
